import { useEffect } from "react";
import { Card, CardBody } from "@nextui-org/card";
import { Chip } from "@nextui-org/chip";
import projectsSectionAnimations from "../../utils/projectsSectionAnimation";
import {GithubSVG, LinkSVG} from "./icons";
import {Link} from "react-router";

export const Project = (project) => {

    const {
        description,
        subdescription,
        title,
        icon,
        imgUrl,
        videoUrl,
        technologies,
        githubUrl,
        websiteUrl,
    } = project;

    useEffect(() => {
        const mq = window.matchMedia("(min-width: 1024px)");
        if (!mq.matches) return projectsSectionAnimations.mobileAnimation();

        projectsSectionAnimations.titleAnimation();
        projectsSectionAnimations.videoAnimation();
        projectsSectionAnimations.descriptionAnimation();
        projectsSectionAnimations.websiteUrlAnimation();
        projectsSectionAnimations.githubUrlAnimation();
    }, []);

    return (
        <div className="grid grid-cols-4 gap-5 pb-4 overflow-hidden">
            <div
                className="flex lg:hidden items-center col-span-full lg:row-start-1 lg:row-end-2 lg:col-start-1 lg:col-end-5 text-2xl lg:text-3xl font-bold text-green-800 dark:text-white opacity-0 mobile-animation titleSection">
                <span className="bg-green-100 dark:bg-[#303036] p-2 rounded-md mr-2"> {icon}</span>
                {title}
            </div>

            <div
                className="col-span-full lg:row-start-1 lg:row-end-4 lg:col-start-1 lg:col-end-3 opacity-0 mobile-animation videoSection">
                <img
                    className="rounded-xl  border-1 border-green-500 dark:border-[#212121] lg:max-h-[380px]"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        background: "#ffffff"
                    }}
                    src={imgUrl}
                />
            </div>

            <Card
                className="col-span-full lg:row-start-1 lg:row-end-3 lg:col-start-3 lg:col-end-5 lg:min-h-[257px] opacity-0 mobile-animation descriptionCard">
                <CardBody className="dark:text-gray-400 text-gray-700 text-lg flex justify-between gap-4 p-5">
                    <div
                        className="hidden lg:flex col-span-full lg:row-start-1 lg:row-end-2 lg:col-start-1 lg:col-end-5 text-3xl font-bold text-green-800 dark:text-white opacity-0 mobile-animation titleSection items-center">
                        <span className="bg-green-100 dark:bg-zinc-800 p-2 rounded-md mr-2"> {icon}</span>&nbsp;
                        {title}
                    </div>
                    {description}<br/>
                    <b>{subdescription}</b>
                    <div className=" flex flex-wrap gap-2">
                        {technologies.map(
                            ({name, icon}, index) => (
                                <Chip
                                    className="bg-green-100 dark:bg-zinc-700"
                                    key={`technology-item-${index}`}
                                    size="sm"
                                >
                                  <span className="flex items-center gap-2">
                                    {/* {icon} */}
                                      {name}
                                  </span>
                                </Chip>
                            )
                        )}
                    </div>
                </CardBody>
            </Card>

            <Card
                isHoverable
                className={`${
                    websiteUrl === "NONE" && "hidden"
                } ${
                    githubUrl === "NONE"
                    ? "lg:col-start-3 col-span-4 lg:col-end-5"
                    : "lg:col-start-3 col-span-2 lg:col-end-4"} lg:row-start-3 lg:row-end-4 lg:max-h-16 opacity-0 mobile-animation githubUrlCard`}
            >
                <Link
                    to={websiteUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="min-h-full flex justify-center items-center"
                >
                    <CardBody className="justify-center items-center text-green-700 dark:text-gray-400">
                        {!websiteUrl ? (
                            <h2 className="font-bold text-xl text-green-700 dark:text-gray-400 text-center">
                                Coming Soon!
                            </h2>
                        ) : (
                            <LinkSVG size={28} color={"currentColor"}/>
                        )}
                    </CardBody>
                </Link>
            </Card>

            <Card
                isHoverable
                className={`${
                    websiteUrl === "NONE"
                        ? "lg:col-start-3 col-span-4"
                        : "lg:col-start-4 col-span-2"
                } ${githubUrl === "NONE" && "hidden"} lg:row-start-3 lg:row-end-4 lg:max-h-16 lg:col-end-5 opacity-0 mobile-animation websiteUrlCard`}
            >
                <Link
                    to={githubUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="min-h-full flex justify-center items-center"
                >
                    <CardBody className="justify-center items-center text-green-700 dark:text-gray-400">
                        <GithubSVG size={28} color={"currentColor"}/>
                    </CardBody>
                </Link>
            </Card>
        </div>
    );
};
